const INGREDIENT_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isExtraDetailsLoading: false,
  isComponentDetailsLoading: false,
  isOverridesIngredientsDetailsLoading: false,
  isAlternativeIngredientsDetailsLoading: false,
  isNotesLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  extraDetailsError: undefined,
  componentDetailsError: undefined,
  overridesIngredientsDetailsError: undefined,
  alternativeIngredientsDetailsError: undefined,
  notesError: undefined,
  data: undefined,
  isAlternativeIngredientsDirty: false,
  isComponentIngredientsDirty: false,
  isExtraIngredientsDirty: false,
  isKeywordsDirty: false,
  isOverridesIngredientsDirty: false,
  isSimpleDetailsDirty: false,
  isNotesDirty: false,
}

export default INGREDIENT_INITIAL_STATE
